import { render, staticRenderFns } from "./DefaultMessagesView.vue?vue&type=template&id=368fdce1"
import script from "./DefaultMessagesView.vue?vue&type=script&lang=js"
export * from "./DefaultMessagesView.vue?vue&type=script&lang=js"
import style0 from "./DefaultMessagesView.vue?vue&type=style&index=0&id=368fdce1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports